// src/composables/lotteryData.js

import maIcon from './img/ma.gif'
import sheIcon from './img/she.gif'
import longIcon from './img/long.gif'
import tuIcon from './img/tu.gif'
import huIcon from './img/hu.gif'
import niuIcon from './img/niu.gif'
import shuIcon from './img/shu.gif'
import zhuIcon from './img/zhu.gif'
import gouIcon from './img/gou.gif'
import jiIcon from './img/ji.gif'
import houIcon from './img/hou.gif'
import yangIcon from './img/yang.gif'

export const iconMap = new Map([
  ['鼠', shuIcon],
  ['牛', niuIcon],
  ['虎', huIcon],
  ['兔', tuIcon],
  ['龙', longIcon],
  ['蛇', sheIcon],
  ['马', maIcon],
  ['羊', yangIcon],
  ['猴', houIcon],
  ['鸡', jiIcon],
  ['狗', gouIcon],
  ['猪', zhuIcon],
])

// 号码完整数据 - 根据正确的数据重新整理
export const lotteryData = [
  // ========== 马 [冲 鼠] 01,13,25,37,49 ==========
  ['01', {
    shengxiao: '马',
    chong: '鼠',
    wuxing: '水',  // 水：01,14,15,22,23,30,31,44,45
    bose: '红',    // 红波：01,02,07,08,12,13,18,19,23,24,29,30,34,35,40,45,46
    heshudanshuang: '单',  // 合数单：01,03,05,07,09,10,12,14,16,18,21,23,25,27,29,30,32,34,36,38,41,43,45,47,49
    shuxing: ['家禽', '吉美', '阴性', '单笔', '天肖', '黑中', '男肖', '日肖', '后肖', '大肖', '右肖', '朝肖', '胆大肖', '三合:虎狗', '六合:羊', '书', '夏', '雷', '红肖']
  }],
  ['13', {
    shengxiao: '马',
    chong: '鼠',
    wuxing: '金',  // 金：04,05,12,13,26,27,34,35,42,43
    bose: '红',    // 红波
    heshudanshuang: '双',  // 合数双：13
    shuxing: ['家禽', '吉美', '阴性', '单笔', '天肖', '黑中', '男肖', '日肖', '后肖', '大肖', '右肖', '朝肖', '胆大肖', '三合:虎狗', '六合:羊', '书', '夏', '雷', '红肖']
  }],
  ['25', {
    shengxiao: '马',
    chong: '鼠',
    wuxing: '木',  // 木：08,09,16,17,24,25,38,39,46,47
    bose: '蓝',    // 蓝波：25
    heshudanshuang: '单',  // 合数单：25
    shuxing: ['家禽', '吉美', '阴性', '单笔', '天肖', '黑中', '男肖', '日肖', '后肖', '大肖', '右肖', '朝肖', '胆大肖', '三合:虎狗', '六合:羊', '书', '夏', '雷', '红肖']
  }],
  ['37', {
    shengxiao: '马',
    chong: '鼠',
    wuxing: '土',  // 土：06,07,20,21,28,29,36,37
    bose: '蓝',    // 蓝波：37
    heshudanshuang: '双',  // 合数单：37
    shuxing: ['家禽', '吉美', '阴性', '单笔', '天肖', '黑中', '男肖', '日肖', '后肖', '大肖', '右肖', '朝肖', '胆大肖', '三合:虎狗', '六合:羊', '书', '夏', '雷', '红肖']
  }],
  ['49', {
    shengxiao: '马',
    chong: '鼠',
    wuxing: '火',  // 火：02,03,10,11,18,19,32,33,40,41,48,49
    bose: '绿',    // 绿波：49
    heshudanshuang: '单',  // 合数单：49
    shuxing: ['家禽', '吉美', '阴性', '单笔', '天肖', '黑中', '男肖', '日肖', '后肖', '大肖', '右肖', '朝肖', '胆大肖', '三合:虎狗', '六合:羊', '书', '夏', '雷', '红肖']
  }],

  // ========== 蛇 [冲 猪] 02,14,26,38 ==========
  ['02', {
    shengxiao: '蛇',
    chong: '猪',
    wuxing: '火',  // 火
    bose: '红',    // 红波
    heshudanshuang: '双',  // 合数双：02
    shuxing: ['野兽', '吉美', '阴性', '单笔', '地肖', '黑中', '女肖', '日肖', '前肖', '小肖', '左肖', '朝肖', '胆小肖', '三合:鸡牛', '六合:猴', '琴', '夏', '雷', '五福肖', '蓝肖']
  }],
  ['14', {
    shengxiao: '蛇',
    chong: '猪',
    wuxing: '水',  // 水
    bose: '蓝',    // 蓝波
    heshudanshuang: '单',  // 合数单：14
    shuxing: ['野兽', '吉美', '阴性', '单笔', '地肖', '黑中', '女肖', '日肖', '前肖', '小肖', '左肖', '朝肖', '胆小肖', '三合:鸡牛', '六合:猴', '琴', '夏', '雷', '五福肖', '蓝肖']
  }],
  ['26', {
    shengxiao: '蛇',
    chong: '猪',
    wuxing: '金',  // 金
    bose: '蓝',    // 蓝波
    heshudanshuang: '双',  // 合数双：26
    shuxing: ['野兽', '吉美', '阴性', '单笔', '地肖', '黑中', '女肖', '日肖', '前肖', '小肖', '左肖', '朝肖', '胆小肖', '三合:鸡牛', '六合:猴', '琴', '夏', '雷', '五福肖', '蓝肖']
  }],
  ['38', {
    shengxiao: '蛇',
    chong: '猪',
    wuxing: '木',  // 木
    bose: '绿',    // 绿波
    heshudanshuang: '单',  // 合数双：38
    shuxing: ['野兽', '吉美', '阴性', '单笔', '地肖', '黑中', '女肖', '日肖', '前肖', '小肖', '左肖', '朝肖', '胆小肖', '三合:鸡牛', '六合:猴', '琴', '夏', '雷', '五福肖', '蓝肖']
  }],

  // ========== 龙 [冲 狗] 03,15,27,39 ==========
  ['03', {
    shengxiao: '龙',
    chong: '狗',
    wuxing: '火',  // 火
    bose: '蓝',    // 蓝波
    heshudanshuang: '单',  // 合数单：03
    shuxing: ['野兽', '吉美', '阴性', '单笔', '天肖', '黑中', '男肖', '日肖', '前肖', '小肖', '左肖', '朝肖', '胆小肖', '三合:鼠猴', '六合:鸡', '书', '春', '风', '绿肖']
  }],
  ['15', {
    shengxiao: '龙',
    chong: '狗',
    wuxing: '水',  // 水
    bose: '蓝',    // 蓝波
    heshudanshuang: '双',  // 合数双：15
    shuxing: ['野兽', '吉美', '阴性', '单笔', '天肖', '黑中', '男肖', '日肖', '前肖', '小肖', '左肖', '朝肖', '胆小肖', '三合:鼠猴', '六合:鸡', '书', '春', '风', '绿肖']
  }],
  ['27', {
    shengxiao: '龙',
    chong: '狗',
    wuxing: '金',  // 金
    bose: '绿',    // 绿波
    heshudanshuang: '单',  // 合数单：27
    shuxing: ['野兽', '吉美', '阴性', '单笔', '天肖', '黑中', '男肖', '日肖', '前肖', '小肖', '左肖', '朝肖', '胆小肖', '三合:鼠猴', '六合:鸡', '书', '春', '风', '绿肖']
  }],
  ['39', {
    shengxiao: '龙',
    chong: '狗',
    wuxing: '木',  // 木
    bose: '绿',    // 绿波
    heshudanshuang: '双',  // 合数单：39
    shuxing: ['野兽', '吉美', '阴性', '单笔', '天肖', '黑中', '男肖', '日肖', '前肖', '小肖', '左肖', '朝肖', '胆小肖', '三合:鼠猴', '六合:鸡', '书', '春', '风', '绿肖']
  }],

  // ========== 兔 [冲 鸡] 04,16,28,40 ==========
  ['04', {
    shengxiao: '兔',
    chong: '鸡',
    wuxing: '金',  // 金
    bose: '蓝',    // 蓝波
    heshudanshuang: '双',  // 合数双：04
    shuxing: ['野兽', '吉美', '阳性', '双笔', '天肖', '黑中', '女肖', '日肖', '前肖', '小肖', '右肖', '朝肖', '胆小肖', '三合:猪羊', '六合:狗', '琴', '春', '风', '五福肖', '红肖']
  }],
  ['16', {
    shengxiao: '兔',
    chong: '鸡',
    wuxing: '木',  // 木
    bose: '绿',    // 绿波
    heshudanshuang: '单',  // 合数单：16
    shuxing: ['野兽', '吉美', '阳性', '双笔', '天肖', '黑中', '女肖', '日肖', '前肖', '小肖', '右肖', '朝肖', '胆小肖', '三合:猪羊', '六合:狗', '琴', '春', '风', '五福肖', '红肖']
  }],
  ['28', {
    shengxiao: '兔',
    chong: '鸡',
    wuxing: '土',  // 土
    bose: '绿',    // 绿波
    heshudanshuang: '双',  // 合数双：28
    shuxing: ['野兽', '吉美', '阳性', '双笔', '天肖', '黑中', '女肖', '日肖', '前肖', '小肖', '右肖', '朝肖', '胆小肖', '三合:猪羊', '六合:狗', '琴', '春', '风', '五福肖', '红肖']
  }],
  ['40', {
    shengxiao: '兔',
    chong: '鸡',
    wuxing: '火',  // 火
    bose: '红',    // 红波
    heshudanshuang: '双',  // 合数双：40
    shuxing: ['野兽', '吉美', '阳性', '双笔', '天肖', '黑中', '女肖', '日肖', '前肖', '小肖', '右肖', '朝肖', '胆小肖', '三合:猪羊', '六合:狗', '琴', '春', '风', '五福肖', '红肖']
  }],

  // ========== 虎 [冲 猴] 05,17,29,41 ==========
  ['05', {
    shengxiao: '虎',
    chong: '猴',
    wuxing: '金',  // 金
    bose: '绿',    // 绿波
    heshudanshuang: '单',  // 合数单：05
    shuxing: ['野兽', '凶丑', '阳性', '双笔', '地肖', '白边', '男肖', '夜肖', '前肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:马狗', '六合:猪', '书', '春', '风', '五福肖', '蓝肖']
  }],
  ['17', {
    shengxiao: '虎',
    chong: '猴',
    wuxing: '木',  // 木
    bose: '绿',    // 绿波
    heshudanshuang: '双',  // 合数双：17
    shuxing: ['野兽', '凶丑', '阳性', '双笔', '地肖', '白边', '男肖', '夜肖', '前肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:马狗', '六合:猪', '书', '春', '风', '五福肖', '蓝肖']
  }],
  ['29', {
    shengxiao: '虎',
    chong: '猴',
    wuxing: '土',  // 土
    bose: '红',    // 红波
    heshudanshuang: '单',  // 合数单：29
    shuxing: ['野兽', '凶丑', '阳性', '双笔', '地肖', '白边', '男肖', '夜肖', '前肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:马狗', '六合:猪', '书', '春', '风', '五福肖', '蓝肖']
  }],
  ['41', {
    shengxiao: '虎',
    chong: '猴',
    wuxing: '火',  // 火
    bose: '蓝',    // 蓝波
    heshudanshuang: '单',  // 合数单：41
    shuxing: ['野兽', '凶丑', '阳性', '双笔', '地肖', '白边', '男肖', '夜肖', '前肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:马狗', '六合:猪', '书', '春', '风', '五福肖', '蓝肖']
  }],

  // ========== 牛 [冲 羊] 06,18,30,42 ==========
  ['06', {
    shengxiao: '牛',
    chong: '羊',
    wuxing: '土',  // 土
    bose: '绿',    // 绿波
    heshudanshuang: '双',  // 合数双：06
    shuxing: ['家禽', '凶丑', '阳性', '双笔', '天肖', '白边', '男肖', '夜肖', '前肖', '大肖', '左肖', '夕肖', '胆大肖', '三合:蛇鸡', '六合:鼠', '棋', '冬', '雨', '绿肖']
  }],
  ['18', {
    shengxiao: '牛',
    chong: '羊',
    wuxing: '火',  // 火
    bose: '红',    // 红波
    heshudanshuang: '单',  // 合数单：18
    shuxing: ['家禽', '凶丑', '阳性', '双笔', '天肖', '白边', '男肖', '夜肖', '前肖', '大肖', '左肖', '夕肖', '胆大肖', '三合:蛇鸡', '六合:鼠', '棋', '冬', '雨', '绿肖']
  }],
  ['30', {
    shengxiao: '牛',
    chong: '羊',
    wuxing: '水',  // 水
    bose: '红',    // 红波
    heshudanshuang: '单',  // 合数双：30
    shuxing: ['家禽', '凶丑', '阳性', '双笔', '天肖', '白边', '男肖', '夜肖', '前肖', '大肖', '左肖', '夕肖', '胆大肖', '三合:蛇鸡', '六合:鼠', '棋', '冬', '雨', '绿肖']
  }],
  ['42', {
    shengxiao: '牛',
    chong: '羊',
    wuxing: '金',  // 金
    bose: '蓝',    // 蓝波
    heshudanshuang: '双',  // 合数双：42
    shuxing: ['家禽', '凶丑', '阳性', '双笔', '天肖', '白边', '男肖', '夜肖', '前肖', '大肖', '左肖', '夕肖', '胆大肖', '三合:蛇鸡', '六合:鼠', '棋', '冬', '雨', '绿肖']
  }],

  // ========== 鼠 [冲 马] 07,19,31,43 ==========
  ['07', {
    shengxiao: '鼠',
    chong: '马',
    wuxing: '土',  // 土
    bose: '红',    // 红波
    heshudanshuang: '单',  // 合数单：07
    shuxing: ['野兽', '凶丑', '阴性', '单笔', '地肖', '白边', '男肖', '夜肖', '前肖', '小肖', '左肖', '夕肖', '胆小肖', '三合:龙猴', '六合:牛', '棋', '冬', '雨', '五福肖', '红肖']
  }],
  ['19', {
    shengxiao: '鼠',
    chong: '马',
    wuxing: '火',  // 火
    bose: '红',    // 红波
    heshudanshuang: '双',  // 合数单：19
    shuxing: ['野兽', '凶丑', '阴性', '单笔', '地肖', '白边', '男肖', '夜肖', '前肖', '小肖', '左肖', '夕肖', '胆小肖', '三合:龙猴', '六合:牛', '棋', '冬', '雨', '五福肖', '红肖']
  }],
  ['31', {
    shengxiao: '鼠',
    chong: '马',
    wuxing: '水',  // 水
    bose: '蓝',    // 蓝波
    heshudanshuang: '双',  // 合数单：31
    shuxing: ['野兽', '凶丑', '阴性', '单笔', '地肖', '白边', '男肖', '夜肖', '前肖', '小肖', '左肖', '夕肖', '胆小肖', '三合:龙猴', '六合:牛', '棋', '冬', '雨', '五福肖', '红肖']
  }],
  ['43', {
    shengxiao: '鼠',
    chong: '马',
    wuxing: '金',  // 金
    bose: '绿',    // 绿波
    heshudanshuang: '单',  // 合数单：43
    shuxing: ['野兽', '凶丑', '阴性', '单笔', '地肖', '白边', '男肖', '夜肖', '前肖', '小肖', '左肖', '夕肖', '胆小肖', '三合:龙猴', '六合:牛', '棋', '冬', '雨', '五福肖', '红肖']
  }],

  // ========== 猪 [冲 蛇] 08,20,32,44 ==========
  ['08', {
    shengxiao: '猪',
    chong: '蛇',
    wuxing: '木',  // 木
    bose: '红',    // 红波
    heshudanshuang: '双',  // 合数双：08
    shuxing: ['家禽', '凶丑', '阴性', '单笔', '天肖', '白边', '女肖', '夜肖', '后肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:兔羊', '六合:虎', '画', '冬', '雨', '蓝肖']
  }],
  ['20', {
    shengxiao: '猪',
    chong: '蛇',
    wuxing: '土',  // 土
    bose: '蓝',    // 蓝波
    heshudanshuang: '双',  // 合数双：20
    shuxing: ['家禽', '凶丑', '阴性', '单笔', '天肖', '白边', '女肖', '夜肖', '后肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:兔羊', '六合:虎', '画', '冬', '雨', '蓝肖']
  }],
  ['32', {
    shengxiao: '猪',
    chong: '蛇',
    wuxing: '火',  // 火
    bose: '绿',    // 绿波
    heshudanshuang: '单',  // 合数双：32
    shuxing: ['家禽', '凶丑', '阴性', '单笔', '天肖', '白边', '女肖', '夜肖', '后肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:兔羊', '六合:虎', '画', '冬', '雨', '蓝肖']
  }],
  ['44', {
    shengxiao: '猪',
    chong: '蛇',
    wuxing: '水',  // 水
    bose: '绿',    // 绿波
    heshudanshuang: '双',  // 合数双：44
    shuxing: ['家禽', '凶丑', '阴性', '单笔', '天肖', '白边', '女肖', '夜肖', '后肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:兔羊', '六合:虎', '画', '冬', '雨', '蓝肖']
  }],

  // ========== 狗 [冲 龙] 09,21,33,45 ==========
  ['09', {
    shengxiao: '狗',
    chong: '龙',
    wuxing: '木',  // 木
    bose: '蓝',    // 蓝波
    heshudanshuang: '单',  // 合数单：09
    shuxing: ['家禽', '凶丑', '阴性', '双笔', '地肖', '白边', '男肖', '夜肖', '后肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:虎马', '六合:兔', '棋', '秋', '电', '绿肖']
  }],
  ['21', {
    shengxiao: '狗',
    chong: '龙',
    wuxing: '土',  // 土
    bose: '绿',    // 绿波
    heshudanshuang: '单',  // 合数单：21
    shuxing: ['家禽', '凶丑', '阴性', '双笔', '地肖', '白边', '男肖', '夜肖', '后肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:虎马', '六合:兔', '棋', '秋', '电', '绿肖']
  }],
  ['33', {
    shengxiao: '狗',
    chong: '龙',
    wuxing: '火',  // 火
    bose: '绿',    // 绿波
    heshudanshuang: '双',  // 合数单：33
    shuxing: ['家禽', '凶丑', '阴性', '双笔', '地肖', '白边', '男肖', '夜肖', '后肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:虎马', '六合:兔', '棋', '秋', '电', '绿肖']
  }],
  ['45', {
    shengxiao: '狗',
    chong: '龙',
    wuxing: '水',  // 水
    bose: '红',    // 红波
    heshudanshuang: '单',  // 合数单：45
    shuxing: ['家禽', '凶丑', '阴性', '双笔', '地肖', '白边', '男肖', '夜肖', '后肖', '大肖', '右肖', '夕肖', '胆大肖', '三合:虎马', '六合:兔', '棋', '秋', '电', '绿肖']
  }],

  // ========== 鸡 [冲 兔] 10,22,34,46 ==========
  ['10', {
    shengxiao: '鸡',
    chong: '兔',
    wuxing: '火',  // 火
    bose: '蓝',    // 蓝波
    heshudanshuang: '单',  // 合数单：10
    shuxing: ['家禽', '吉美', '阳性', '单笔', '地肖', '白边', '女肖', '夜肖', '后肖', '小肖', '左肖', '夕肖', '胆小肖', '三合:蛇牛', '六合:龙', '琴', '秋', '电', '红肖']
  }],
  ['22', {
    shengxiao: '鸡',
    chong: '兔',
    wuxing: '水',  // 水
    bose: '绿',    // 绿波
    heshudanshuang: '双',  // 合数双：22
    shuxing: ['家禽', '吉美', '阳性', '单笔', '地肖', '白边', '女肖', '夜肖', '后肖', '小肖', '左肖', '夕肖', '胆小肖', '三合:蛇牛', '六合:龙', '琴', '秋', '电', '红肖']
  }],
  ['34', {
    shengxiao: '鸡',
    chong: '兔',
    wuxing: '金',  // 金
    bose: '红',    // 红波
    heshudanshuang: '单',  // 合数双：34
    shuxing: ['家禽', '吉美', '阳性', '单笔', '地肖', '白边', '女肖', '夜肖', '后肖', '小肖', '左肖', '夕肖', '胆小肖', '三合:蛇牛', '六合:龙', '琴', '秋', '电', '红肖']
  }],
  ['46', {
    shengxiao: '鸡',
    chong: '兔',
    wuxing: '木',  // 木
    bose: '红',    // 红波
    heshudanshuang: '双',  // 合数双：46
    shuxing: ['家禽', '吉美', '阳性', '单笔', '地肖', '白边', '女肖', '夜肖', '后肖', '小肖', '左肖', '夕肖', '胆小肖', '三合:蛇牛', '六合:龙', '琴', '秋', '电', '红肖']
  }],

  // ========== 猴 [冲 虎] 11,23,35,47 ==========
  ['11', {
    shengxiao: '猴',
    chong: '虎',
    wuxing: '火',  // 火
    bose: '绿',    // 绿波
    heshudanshuang: '双',  // 合数双：11
    shuxing: ['野兽', '凶丑', '阳性', '双笔', '天肖', '黑中', '男肖', '日肖', '后肖', '小肖', '左肖', '朝肖', '胆大肖', '三合:鼠龙', '六合:蛇', '画', '秋', '电', '五福肖', '蓝肖']
  }],
  ['23', {
    shengxiao: '猴',
    chong: '虎',
    wuxing: '水',  // 水
    bose: '红',    // 红波
    heshudanshuang: '单',  // 合数单：23
    shuxing: ['野兽', '凶丑', '阳性', '双笔', '天肖', '黑中', '男肖', '日肖', '后肖', '小肖', '左肖', '朝肖', '胆大肖', '三合:鼠龙', '六合:蛇', '画', '秋', '电', '五福肖', '蓝肖']
  }],
  ['35', {
    shengxiao: '猴',
    chong: '虎',
    wuxing: '金',  // 金
    bose: '红',    // 红波
    heshudanshuang: '双',  // 合数单：35
    shuxing: ['野兽', '凶丑', '阳性', '双笔', '天肖', '黑中', '男肖', '日肖', '后肖', '小肖', '左肖', '朝肖', '胆大肖', '三合:鼠龙', '六合:蛇', '画', '秋', '电', '五福肖', '蓝肖']
  }],
  ['47', {
    shengxiao: '猴',
    chong: '虎',
    wuxing: '木',  // 木
    bose: '蓝',    // 蓝波
    heshudanshuang: '单',  // 合数单：47
    shuxing: ['野兽', '凶丑', '阳性', '双笔', '天肖', '黑中', '男肖', '日肖', '后肖', '小肖', '左肖', '朝肖', '胆大肖', '三合:鼠龙', '六合:蛇', '画', '秋', '电', '五福肖', '蓝肖']
  }],

  // ========== 羊 [冲 牛] 12,24,36,48 ==========
  ['12', {
    shengxiao: '羊',
    chong: '牛',
    wuxing: '金',  // 金
    bose: '红',    // 红波
    heshudanshuang: '单',  // 合数单：12
    shuxing: ['家禽', '吉美', '阳性', '双笔', '地肖', '黑中', '女肖', '日肖', '后肖', '大肖', '右肖', '朝肖', '胆小肖', '三合:猪兔', '六合:马', '画', '夏', '雷', '绿肖']
  }],
  ['24', {
    shengxiao: '羊',
    chong: '牛',
    wuxing: '木',  // 木
    bose: '红',    // 红波
    heshudanshuang: '双',  // 合数双：24
    shuxing: ['家禽', '吉美', '阳性', '双笔', '地肖', '黑中', '女肖', '日肖', '后肖', '大肖', '右肖', '朝肖', '胆小肖', '三合:猪兔', '六合:马', '画', '夏', '雷', '绿肖']
  }],
  ['36', {
    shengxiao: '羊',
    chong: '牛',
    wuxing: '土',  // 土
    bose: '蓝',    // 蓝波
    heshudanshuang: '单',  // 合数双：36
    shuxing: ['家禽', '吉美', '阳性', '双笔', '地肖', '黑中', '女肖', '日肖', '后肖', '大肖', '右肖', '朝肖', '胆小肖', '三合:猪兔', '六合:马', '画', '夏', '雷', '绿肖']
  }],
  ['48', {
    shengxiao: '羊',
    chong: '牛',
    wuxing: '火',  // 火
    bose: '蓝',    // 蓝波
    heshudanshuang: '双',  // 合数双：48
    shuxing: ['家禽', '吉美', '阳性', '双笔', '地肖', '黑中', '女肖', '日肖', '后肖', '大肖', '右肖', '朝肖', '胆小肖', '三合:猪兔', '六合:马', '画', '夏', '雷', '绿肖']
  }]
]

lotteryData.sort((a, b) => parseInt(a) - parseInt(b))

export const lotteryDataMap = new Map(lotteryData.map(item => {
  return [item[0], item[1]]
}))

// 波色颜色映射（用于显示）
export const waveColorMap = {
  '红': '#e74c3c',
  '蓝': '#3498db',
  '绿': '#27ae60'
}

// 波色浅色背景映射（用于号码标签）
export const boseLightColorMap = {
  '红': '#f9e6e6',
  '蓝': '#e6f0f9',
  '绿': '#e6f9e6'
}